export default class MarketplaceTeamInvitationAPIRequest {
    inviteeId?: string;
    teamId?: string;
    message?: string;
}
